import type { FeaturePurchaseOfferDefinition } from "@slot/game-shell";

/**
 * The game's four offers (ids are the server contract — they ride the spin request verbatim):
 *   bonus_buy ("requestedFeatureIdentifier"):
 *     - super_bonus_buy — free spins with the SAVED TOTAL (the session's best VS result is kept server-side and every
 *       later battle opens on it; the HUD panel shows it): the first battle has no saved contender, every later one's
 *       top value is the saved total.
 *     - vs_rush_buy — free spins with frequent VS battles.
 *   feature_mode ("requestedFeatureModeIdentifier", per-spin modes, one active at a time):
 *     - bonus_hunt_mode — a higher free-spins trigger chance.
 *     - guaranteed_vs_mode — a VS lands on every spin.
 * Prices come from the initial settings (`featurePriceMultipliersById` / `featureModeMultipliersById`). The icons are
 * frames of the `feature-purchase` sheet.
 */
export function createFeaturePurchaseOffers(): FeaturePurchaseOfferDefinition[] {
  return [
    {
      id: "super_bonus_buy",
      actionType: "bonus_buy",
      titleKey: "feature_purchase.super_bonus_buy.title",
      descriptionKey: "feature_purchase.super_bonus_buy.description",
      fallbackTitle: "Super Bonus Buy",
      fallbackDescription: "Free spins where your best VS result is saved as the minimum for the next VS battle.",
      iconPath: "feature-purchase/feature-purchase/4fs",
    },
    {
      id: "vs_rush_buy",
      actionType: "bonus_buy",
      titleKey: "feature_purchase.vs_rush_buy.title",
      descriptionKey: "feature_purchase.vs_rush_buy.description",
      fallbackTitle: "VS Rush",
      fallbackDescription: "Free spins with VS battles dropping far more often.",
      iconPath: "feature-purchase/feature-purchase/3vs",
    },
    {
      id: "bonus_hunt_mode",
      actionType: "feature_mode",
      titleKey: "feature_purchase.bonus_hunt_mode.title",
      descriptionKey: "feature_purchase.bonus_hunt_mode.description",
      fallbackTitle: "Bonushunt Featurespins",
      fallbackDescription: "Each spin is more likely to trigger a bonus game.",
      iconPath: "feature-purchase/feature-purchase/fs",
    },
    {
      id: "guaranteed_vs_mode",
      actionType: "feature_mode",
      titleKey: "feature_purchase.guaranteed_vs_mode.title",
      descriptionKey: "feature_purchase.guaranteed_vs_mode.description",
      fallbackTitle: "Guaranteed VS",
      fallbackDescription: "At least one VS battle lands on every spin.",
      iconPath: "feature-purchase/feature-purchase/vs",
    },
  ];
}
